import BaseComponent from "../../redare/components/BaseComponent";
import {Modal} from "antd";
import React from "react";
import UserPwdFormContent from "./UserPwdFormContent";
import UserPresenter from "../../.gen/presenter/UserPresenter";

export default class UserPwdForm extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible:false,
            showLoading:false
        }
        this.userPrestnter = new UserPresenter(this);
    }

    _show(userId){
        this.setState({modalVisible:true,userId});
    }

    _hide(){
        this.setState({modalVisible:false,showLoading:false})
    }

    //修改用户密码
    _onPasswordModifyConfirm() {
        let {userId} = this.state;
        this.passwordForm.form.validateFields().then(values=>{
            console.log(values)
            let {pwd, pwd1} = values;
            if (pwd !== pwd1) {
                this.toastWarning("两次输入密码不一致");
                return
            }
            values.accountId = userId;
            this.setState({showLoading:true});
            this.userPrestnter.modifyPwd(
                values,
                {},
                () => {
                    this.toastSuccess("密码修改成功");
                    this._hide();
                },
                () => {
                    this.setState({showLoading:false});
                }
            )
        }).catch(errorInfo=>{
            console.log(errorInfo);
        });
    }

    render() {
        let {modalVisible,showLoading} = this.state;
        return (
            <Modal
                title="修改密码"
                visible={modalVisible}
                confirmLoading={showLoading}
                onOk={() => this._onPasswordModifyConfirm(false)}
                onCancel={() => this._hide()}
                destroyOnClose={true}
                maskClosable={false}
                centered={true}
                okText={'确认'}
                cancelText={'取消'}
            >
                <UserPwdFormContent ref={(o) => {this.passwordForm = o}}/>
            </Modal>
        )
    }
}